export function init() {
    console.log("[loaded] modal");
    const modal = document.querySelector(".tx-sf-banners");
    const background = modal?.firstElementChild;
    if (!modal || !background) return;
    
    const modalId = background.getAttribute("id");
    const cookieName = `modal-${modalId || "without-id"}-closed`;
    let closeButton

    const prepareMarkup = () => {
        const contentContainer = modal.querySelector(".banner");
        // Prepare markup:
        // The markup is created by a library. We need to add our own classes
        // and the close button.
        modal.classList.add("modal");
        background.classList.add("modal__background");
        contentContainer.classList.add("modal__content-container");
        // Add close button
        closeButton = document.createElement("button");
        const closeIcon = `
        <svg id="icon-close" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.446 10L20 18.554L18.553 20L10 11.446L1.44601 20L0 18.554L8.553 10L0 1.446L1.44601 0L10 8.554L18.553 0L20 1.446L11.446 10Z" fill="currentColor"/>
        </svg>
        `;
        closeButton.innerHTML = closeIcon;
        closeButton.classList.add("modal__close-button");
        contentContainer.appendChild(closeButton);
    }

    function setCookie() {
        const expirationDate = new Date();
        const sevenDays = 7 * 24 * 60 * 60 * 1000;
        expirationDate.setTime(expirationDate.getTime() + sevenDays);
        // cookie expires in seven days
        let expires = "expires=" + expirationDate.toUTCString();
        document.cookie = cookieName + "=" + "true" + ";" + expires + ";path=/";
    }

    function getCookie() {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let cookies = decodedCookie.split(";");

        const cookie = cookies.find((cookie) => cookie.includes(name));
        if (cookie) {
            return cookie.trim().split("=");
        }

        return "";
    }

    function checkCookie() {
        // Check if modal cookie exists and if not, open modal
        let [cookie, value] = getCookie();
        if (cookie === "" || value !== "true") {
            prepareMarkup();
            openModal();
        } else {
            const cookieExists = true;
            closeModal(cookieExists);
        }
        observer.disconnect();
    }

    const closeModal = (cookieExists) => {
        modal.classList.remove("modal--is-open");
        modal.classList.add("modal--is-closed");
        if (!cookieExists) {
            setCookie();
        }
    };

    const onBackgroundClick = (e) => {
        if (e.target.classList.contains("modal__background")) {
            closeModal();
        }
    };

    const addEventListeners = () => {
        if (closeButton) {
            closeButton.addEventListener("click", () => closeModal());
        }
        if (background) {
            background.addEventListener("click", onBackgroundClick);
        }
    };

    const openModal = () => {
        modal.classList.add("modal--is-open");
        addEventListeners();
    };

    const observer = new MutationObserver(checkCookie);

    observer.observe(background, {childList: true})
}
